<header
  *ngIf="{
    isHandset: isHandset$ | async,
    currentUser: displayedCurrentUser(),
    avatarUrl: avatarUrl(),
    isLoggingOut: isLoggingOut$ | async,
    tasksCount: tasksCount$ | async,
    isSuperAdmin: isSuperAdmin$ | async,
    stickerStatistics: stickerStatistics$ | async,
    currentOrganization: currentOrganization()
  } as STATE"
  class="toolbar"
>
  <div class="toolbar__content">
    <section class="toolbar__actions">
      @if (STATE.isSuperAdmin) {
        @if (STATE.currentOrganization) {
          <div class="toolbar__super-admin-alert">
            <div
              class="toolbar__super-admin-alert__content toolbar__alert toolbar__alert--info"
            >
              <mat-icon
                [svgIcon]="'dgi-information-diamond'"
                class="toolbar__super-admin-alert__icon"
              ></mat-icon>
              <span>
                Vous êtes connecté au compte entreprise :
                <span class="toolbar__super-admin-alert__highlight">
                  {{ STATE.currentOrganization.name }}
                  <span class="toolbar__super-admin-alert__separator">-</span>
                  {{ STATE.currentOrganization.nif }}
                </span>
              </span>
              <button
                type="button"
                class="toolbar__super-admin-alert__cta"
                (click)="navigateToBackoffice()"
              >
                <mat-icon [svgIcon]="'dgi-circle-arrow-left-02'"></mat-icon>
                Retour console admin
              </button>
            </div>
          </div>
        }
      } @else {
        <button
          class="toolbar__actions toolbar__actions--toogle"
          type="button"
          aria-label="Toggle sidenav"
          mat-icon-button
          (click)="onToggleMenu()"
        >
          <mat-icon svgIcon="dgi-menu" color="primary"></mat-icon>
        </button>
        <button
          type="button"
          class="toolbar__actions toolbar__actions--invoice"
          (click)="openInvoiceFormModal()"
          *ngxPermissionsOnly="[permission.CREATE_INVOICE]"
          matTooltip="Créez et générez une facture certifiée"
          matTooltipPosition="below"
        >
          <mat-icon
            [svgIcon]="'dgi-add-circle-rounded'"
            color="primary"
          ></mat-icon>
          <span class="hidden sm:inline">Emettre une facture</span>
        </button>

        <button
          type="button"
          class="toolbar__actions toolbar__actions--task"
          routerLink="/import-task"
          matTooltip="Consultez les opérations en cours de traitement et leurs statuts"
          matTooltipPosition="below"
        >
          <mat-icon [svgIcon]="'dgi-orbit'" color="secondary"></mat-icon>
          Tâches en cours
          {{ STATE.tasksCount || 0 }}
        </button>
        <ng-container
          *ngIf="
            STATE.stickerStatistics && STATE.currentUser && showStickerAlert()
          "
        >
          @if (
            $any(STATE.stickerStatistics)?.currentBalance.amount <=
            $any(STATE.stickerStatistics)?.alertLimit
          ) {
            <a
              class="toolbar__actions toolbar__actions--sticker toolbar__alert toolbar__alert--danger"
              type="button"
              (click)="openBuyStickersForm()"
              matTooltip="Alerte indiquant que votre solde de stickers est proche du seuil minimal"
              matTooltipPosition="below"
            >
              <mat-icon [svgIcon]="'dgi-alert-02'" color="secondary"></mat-icon>
              Votre stock de stickers est bas. <span>Cliquez ici</span> pour le
              recharger et assurer la continuité de vos opérations.
              <div
                class="toolbar__actions--sticker-close"
                (click)="dismissStickerAlert($event)"
                aria-label="Fermer l'alerte"
              >
                ×
              </div>
            </a>
          }
        </ng-container>
      }
      <!--  @if (STATE.isSuperAdmin && STATE.currentOrganization) {
        <div class="toolbar__super-admin-alert">
          <div
            class="toolbar__super-admin-alert__content toolbar__alert toolbar__alert--info"
          >
            <mat-icon
              [svgIcon]="'dgi-information-diamond'"
              class="toolbar__super-admin-alert__icon"
            ></mat-icon>
            <span>
              Vous êtes connecté au compte entreprise :
              <span class="toolbar__super-admin-alert__highlight">
                {{ STATE.currentOrganization.name }}
                <span class="toolbar__super-admin-alert__separator">-</span>
                {{ STATE.currentOrganization.nif }}
              </span>
            </span>
            <a
              class="toolbar__super-admin-alert__cta"
              [href]="backofficeHomeUrl"
            >
              <mat-icon [svgIcon]="'dgi-circle-arrow-left-02'"></mat-icon>
              Retour console admin
            </a>
          </div>
        </div>
      } -->
    </section>

    <section *ngIf="STATE.currentUser" class="toolbar__user">
      <!--  <span
        class="toolbar__bell-icon"
        matTooltip="Notification(s)"
        matTooltipPosition="below"
      >
        <img [lazyLoad]="'/assets/icons/bell-pin.svg'" alt="Notifications" />
      </span> -->
      <div
        [matMenuTriggerFor]="menu"
        matTooltip="Configuration du compte"
        matTooltipPosition="below"
      >
        <span class="toolbar__user__icon">
          <img [lazyLoad]="'/assets/icons/admin.svg'" alt="Menu utilisateur" />
        </span>
      </div>

      <mat-menu #menu="matMenu">
        <section class="profile">
          <article class="profile__container">
            <div class="profile__container-avatar">
              <img
                [lazyLoad]="STATE.avatarUrl"
                [width]="42"
                [height]="42"
                [alt]="
                  STATE.currentUser.firstName + ' ' + STATE.currentUser.lastName
                "
              />
            </div>
            <div class="profile__container-infos">
              <h3 class="profile__container-infos__name">
                {{ STATE.currentUser.firstName }}
                {{ STATE.currentUser.lastName }}
              </h3>
              <p *ngIf="!roleVisible" class="profile__container-infos__role">
                {{ STATE.currentUser.role.name }}
              </p>
            </div>
          </article>
        </section>
        <div class="divider"></div>
        <a routerLink="{{ routes.accountSetting }}" mat-menu-item>
          <mat-icon svgIcon="dgi-settings"></mat-icon>
          Paramètres du compte
        </a>

        <a routerLink="{{ routes.accountSecurity }}" mat-menu-item>
          <mat-icon svgIcon="dgi-square-lock-01"></mat-icon>
          Paramètres de sécurité
        </a>

        <button
          (click)="logout()"
          [disabled]="STATE.isLoggingOut"
          mat-menu-item
        >
          <div class="logout-btn">
            <mat-icon svgIcon="dgi-logout-02"></mat-icon>
            Se déconnecter
          </div>
        </button>
      </mat-menu>
    </section>
  </div>
</header>
